//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "driver-supplier",
  data(){
    return{
      supList:[]
    }
  },
  mounted(){
    let tel = this.$route.params.tel;
    this.$loadingShow();
    this.$get(`api/driver/tel/${tel}`).then((res) => {
      if(res.suppliers){
        this.supList = res.suppliers;
      }
      this.$loadingHide();
    }).catch(() => {
      this.$loadingHide();
    })
  }
}



// WEBPACK FOOTER //
// ./src/page/driver/driver-supplier.vue